<script setup lang="ts">
import { computed } from 'vue';

defineOptions({
	name: 'LayoutTableFieldPathLabel',
});

const { labels } = defineProps<{
	labels: string[];
}>();

const parentLabels = computed(() => labels.slice(0, -1));
const leafLabel = computed(() => labels.at(-1) ?? '');
</script>

<template>
	<span class="flex max-w-full min-w-0 items-center gap-1">
		<span
			v-if="parentLabels.length > 0"
			data-testid="field-path-label-parents"
			class="flex min-w-0 shrink-999 items-center gap-1 text-muted"
		>
			<template v-for="(label, index) in parentLabels" :key="`${label}-${index}`">
				<span class="min-w-0 truncate">{{ label }}</span>
				<DIcon name="lucide:chevron-right" class="size-3 shrink-0 text-muted" />
			</template>
		</span>
		<span data-testid="field-path-label-leaf" class="min-w-0 shrink truncate">{{ leafLabel }}</span>
	</span>
</template>
